import { reactive } from 'vue';

import { IState } from '../interfaces';
import { Page } from '../pagination/Page';
import { ApplicationStatusOptions } from '../models/application-status/ApplicationStatusOptions';
import PhdPortalDefinition from '../models/definition/phd/PhdPortalDefinition';
import {
	AreaFilter,
	AttendanceFilter,
	CampaignTypeFilter,
	ContinentFilter,
	CountryFilter,
	DegreeTypeFilter,
	DisciplineFilter,
	DurationFilter,
	EducationLevelFilter,
	EducationalFormFilter,
	FormatFilter,
	KeywordWhatFilter,
	KeywordWhereFilter,
	OrganisationFilter,
	SpecialProgrammesFilter,
	TuitionFeeFilter,
} from '../models/filter';
import { ParameterType, SortingType } from '@/study-search/enums';
import { FilterFacets } from '@/study-search/domain';

import { PortalType } from '@studyportals/domain-client';

const state: IState = reactive({
	filters: [
		new DegreeTypeFilter(),
		new DurationFilter(),
		new FormatFilter(),
		new TuitionFeeFilter(),
		new AttendanceFilter(),
		new DisciplineFilter(),
		new SpecialProgrammesFilter(),
		new CountryFilter(),
		new ContinentFilter(),
		new AreaFilter(),
		new KeywordWhatFilter(),
		new KeywordWhereFilter(),
		new OrganisationFilter(),
		new EducationalFormFilter(),
		new EducationLevelFilter(),
		new CampaignTypeFilter(),
	],
	facets: [
		new FilterFacets(ParameterType.DEGREE_TYPE, []),
		new FilterFacets(ParameterType.DURATION, []),
		new FilterFacets(ParameterType.ATTENDANCE, []),
		new FilterFacets(ParameterType.TUITION_FEE, []),
		new FilterFacets(ParameterType.DELIVERY_METHOD, []),
		new FilterFacets(ParameterType.DISCIPLINES, []),
		new FilterFacets(ParameterType.SPECIAL_PROGRAMMES, []),
		new FilterFacets(ParameterType.EDUCATION_LEVEL, []),
		new FilterFacets(ParameterType.COUNTRY, []),
		new FilterFacets(ParameterType.CONTINENT, []),
		new FilterFacets(ParameterType.AREA, []),
		new FilterFacets(ParameterType.EDUCATIONAL_FORM, []),
		new FilterFacets(ParameterType.EDUCATION_LEVEL, []),
		new FilterFacets(ParameterType.CAMPAIGN_TYPE, []),
	],
	portalType: PortalType.PHD,
	searchResults: [],
	faqStaticContent: null,
	searchResultsCount: 0,
	previousSearchQuery: [],
	userCountryIso: undefined,
	userCurrency: undefined,
	eea: false,
	page: new Page(),
	canonical: `${location.origin}${location.pathname}`,
	currencyRates: [],
	areDependenciesLoaded: false,
	applicationStatus: ApplicationStatusOptions.INITIALIZING,
	portalDefinition: PhdPortalDefinition,
	trackedStudyCardIds: [],
	expandedCountryCheckboxes: [],
	metaRefreshInfo: '',
	countryResidence: -1,
	isGAIQuestionnaireTaken: false,
	sorting: SortingType.RELEVANCE,
	previousSorting: SortingType.RELEVANCE,
	currentPostHogExperiment: undefined,
});

export default state;
